// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
// 引入 store
import store from "./store/index";
import request from "@/api/index.js";
import useChain from "./utils/$c.js";
import "./assets/css/base.less";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueClipboard from 'v-clipboard'
import './assets/iconfont/iconfont.css'
import Vue2OrgTree from 'vue-tree-color'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import VueLazyload from "vue-lazyload"
import infiniteScroll from 'vue-infinite-scroll';

import 'highlight.js/styles/monokai-sublime.min.css';

import ThumbBar from "@/components/thumb-bar";
 
Vue.component('vue-draggable-resizable', VueDraggableResizable)

Vue.prototype.$request = request; // 接口文件
Vue.prototype.$c = useChain;
Vue.config.productionTip = false;
Vue.use(Vue2OrgTree)
Vue.use(ElementUI);
Vue.use(VueClipboard);
Vue.use(infiniteScroll);

Vue.component("ThumbBar", ThumbBar);
Vue.use(VueLazyload, {
  //loading: require('./assets/img/common/placeholder.png'),
  //error: require('./assets/img/common/error.png'),
})
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  beforeCreate() {
    Vue.prototype.$bus=this
  },
});



// WEBPACK FOOTER //
// ./src/main.js